import baseTheme from './mockingbirdBaseTheme'

const mockingbirdNewNavTheme = {
    ...baseTheme,
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    main: '#1E8C80',
                    dark: '#146A61',
                    light: '#3BB3A0',
                    contrastText: '#FFFFFF',
                },
                secondary: {
                    main: '#3E5F74',
                    contrastText: '#FFFFFF',
                },
                background: {
                    default: '#F4F8F6',
                    paper: '#FDFEFD',
                },
                text: {
                    primary: '#33423F',
                    secondary: '#5C6B67',
                },
                divider: 'rgba(0,0,0,0.12)',
                action: {
                    selected: '#D3E5DE',
                    hover: 'rgba(36,65,63,0.06)',
                },
            },
        },
        dark: {
            palette: {
                primary: {
                    main: '#4dd0bc',
                    dark: '#3bb3a0',
                    light: '#7fe0d0',
                    contrastText: '#08221F',
                },
                secondary: {
                    main: '#6E8CA0',
                    contrastText: '#08151E',
                },
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
                text: {
                    primary: '#E4E6E6',
                    secondary: '#A6ABAB',
                },
                divider: 'rgba(255,255,255,0.12)',
                action: {
                    selected: 'rgba(77,208,188,0.16)',
                    hover: 'rgba(255,255,255,0.08)',
                },
            },
        },
    },
}

export default mockingbirdNewNavTheme
